import { render, staticRenderFns } from "./FinanceProductType.vue?vue&type=template&id=5240ee88&scoped=true&"
import script from "./FinanceProductType.vue?vue&type=script&lang=js&"
export * from "./FinanceProductType.vue?vue&type=script&lang=js&"
import style0 from "./FinanceProductType.vue?vue&type=style&index=0&id=5240ee88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5240ee88",
  null
  
)

export default component.exports